// removed by extract-text-webpack-plugin
module.exports = {"councilWrapper":"region-map-module__councilWrapper___1VUlr","mapWrapper":"region-map-module__mapWrapper___3uoG5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/region-map/region-map.module.scss
// module id = 639
// module chunks = 0 1